import React, { useState, useContext } from "react";
import './ShipmentListTable.scss';
import { Table } from 'antd';
import ShipmentListCardOptions from '../ShipmentListCardOptions/ShipmentListCardOptions';
import { getIcon } from '../../../utils/images';
import UserContext from "../../../context/UserContext";
import { Cargo, Logo, ReferenceNumber, RouteTrack, Status, Tags } from "./ColumnComponents";
import NowlunFormContext from "../../../context/NowlunFormContext";

const ShipmentListTable = ({ shipments, updates, selectShipment, refetch, tagSummary }) => {
  const [shipmentOptionsOpened, setShipmentOptionsOpened] = useState(null)
  const { user } = useContext(UserContext)
  const hasCompany = shipments.some((shipment) => shipment.company);
  const { setShowEditNowlunForm } = useContext(NowlunFormContext);

  const clickRow = (shipment) => {
    selectShipment(shipment)
    setShipmentOptionsOpened(null)
  }

  const renderCargo = window.innerWidth > 1030;

  let columns = [
    {
      title: '',
      dataIndex: 'star',
      key: 'icon',
      render: (star, shipment) => {
        return <Logo star={star} shipment={shipment} getIcon={getIcon} clickRow={clickRow} />
      },
      width: "5%"
    },
    {
      title: 'Ref #',
      dataIndex: 'booking_number',
      key: 'booking_number',
      render: (booking_number, shipment) => {
        return <ReferenceNumber booking_number={booking_number} shipment={shipment} clickRow={clickRow} user={user} />
      },
      width: "10%"
    },
    {
      ...(hasCompany && {
        title: 'Company',
        dataIndex: 'company',
        key: 'company',
        render: (company) => (company ? <div className="company">{company}</div> : null),
        width: "8%",
      })
    },
    {
      title: 'Route',
      dataIndex: '',
      key: 'track',
      className: 'centered',
      render: (_, shipment) => {
        return <RouteTrack shipment={shipment} clickRow={clickRow} />
      },
    },
    {
      title: 'Status',
      dataIndex: 'state',
      key: 'state',
      render: (state, shipment) => {
        return <Status state={state} shipment={shipment} updates={updates} clickRow={clickRow} />
      },
      width: "20%"
    },
    {
      ...(renderCargo && {
        title: 'Cargo',
        dataIndex: 'cargo',
        key: 'cargo',
        className: 'cargo-col',
        render: (cargo, shipment) => {
          return <Cargo cargo={cargo} shipment={shipment} clickRow={clickRow} />
        },
        width: "12%"
      })
    },
    {
      title: '',
      dataIndex: 'tags',
      key: 'tags',
      render: (tags, shipment) => {
        return <Tags tags={tags} shipment={shipment} tagSummary={tagSummary} clickRow={clickRow} />
      },
      width: "12%"
    },
    {
      title: '',
      dataIndex: '',
      key: 'popover',
      render: (_, shipment) => {
        return (
          shipment.group?.length && <ShipmentListCardOptions 
            shipment={shipment} 
            refetch={refetch} 
            shipmentOptionsOpened={shipmentOptionsOpened} 
            setShipmentOptionsOpened={setShipmentOptionsOpened}
            onShowNowlunForm={setShowEditNowlunForm}
          />
        )
      },
      width: "5%"
    },
  ];

  columns = columns.filter((c) => Object.keys(c).length)

  const expandedColumns = [
    {
      title: '',
      dataIndex: '',
      key: 'left-pad',
      className: 'ant-table-row-expand-icon-cell',
      width: "18px"
    },
    ...columns
  ]

  return (
    <div className="ShipmentListTable">
      <Table
        tableLayout="fixed"
        rowClassName={"ant-table-row"}
        dataSource={shipments}
        columns={columns}
        pagination={{ position: ["none", "none"], pageSize: 25 }}
        rowKey="id"
        expandable={{
          expandedRowRender: (record) => (
            <div className="listing-table-wrapper">
              <Table
                tableLayout="fixed"
                className="listing-table"
                rowClassName={"ant-table-row"}
                dataSource={record.group}
                columns={expandedColumns}
                rowKey="id"
                showHeader={false}
                pagination={false}
              />
            </div>
          ),
          columnWidth: "18px",
          expandIcon: ({ expanded, onExpand, record }) => {
            return record.group.length > 1 && <div className="expand-icon"><img className={expanded ? "expanded" : ""} src={getIcon('table-expand')} onClick={e => onExpand(record, e)} /></div>
          }
        }}
      />
    </div>
  )
}

export default ShipmentListTable;
